/**
 * Canonical site URLs for SEO (meta, OG, JSON-LD).
 * Set REACT_APP_PUBLIC_SITE_URL at build time (e.g. https://jobmockai.com).
 */

export const SITE_NAME = 'JobMockAI';

/** Primary domain — aligns with backend PUBLIC_SITE_URL / sitemap defaults */
export const DEFAULT_CANONICAL_ORIGIN = 'https://jobmockai.com';

/**
 * Origin used for canonical links and absolute OG/JSON-LD URLs.
 * In production with REACT_APP_PUBLIC_SITE_URL set → use that (single canonical domain).
 * Otherwise → current browser origin (local dev or deploy URL).
 */
export function getCanonicalOrigin() {
  const envOrigin = (process.env.REACT_APP_PUBLIC_SITE_URL || '').replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    if (process.env.NODE_ENV === 'production' && envOrigin) {
      return envOrigin;
    }
    return window.location.origin;
  }
  return envOrigin || DEFAULT_CANONICAL_ORIGIN;
}

export function absoluteUrl(path) {
  const base = getCanonicalOrigin().replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}

/** Default share image (must be absolute HTTPS on production) */
export function defaultOgImageUrl() {
  return absoluteUrl('/icon-512x512.svg');
}
